module.exports = __webpack_public_path__ + "img/logo.731274f1.png";